import { EPageSubmenuType } from '@hts/shared/enums';
import { IMappedSubmenu, IMappedSubmenuCategory } from '@hts/shared/types';
import { useMemo } from 'react';

export const useGetTopMenu1Categories = (submenus: IMappedSubmenu[] = [], type: EPageSubmenuType) =>
  useMemo<IMappedSubmenuCategory[]>(
    () => submenus.find((submenu) => submenu.type === type)?.categories || [],
    [submenus, type]
  );
